export default "__VITE_ASSET__CvfFqW_3__"